import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { useRef } from "react";

import { semvApi } from "../../../../../shared/services/axios/apis.service";
import { GovPlanSecretaryProjectContract } from "./contracts/project";
import { GovPlanSecretaryProject } from "./model/project";
import { GovPlanProjectDetails } from "./content/details";
import { GovPlanProjectRoadmapList } from "./content/roadmap-list";
import {
    ProjectRoadmapItemDetails,
    ProjectRoadmapItemDetailsModalHandles,
} from "./components/roadmap-item/roadmap-item-details";

export const SecretaryProjectDetail = () => {
    const createRoadmapItemRef =
        useRef<ProjectRoadmapItemDetailsModalHandles>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const { projectId } = useParams();

    const { data } = useQuery({
        queryKey: [
            "gov-plan-secretary-one-project",
            projectId,
            searchParams.get("t"),
        ],
        queryFn: async () => {
            const response = await semvApi.get<{
                project: GovPlanSecretaryProjectContract;
            }>(`/government-plan/projects/${projectId}`);

            return new GovPlanSecretaryProject(response.data.project);
        },
    });

    const handleOnClick = (tab: string | null) => {
        const draft = new URLSearchParams(searchParams);
        draft.set("tab", tab ?? "details");
        setSearchParams(draft);
    };

    if (!data || !projectId) return null;

    return (
        <>
            <header className="w-full h-28 border-b border-slate-500 flex justify-between">
                <h5 className="text-slate-700 pt-5 pl-4">
                    Projeto {data.name}
                </h5>

                <section className="self-end flex space-x-4">
                    <button
                        type="button"
                        className="btn-primary mb-2"
                        onClick={() =>
                            createRoadmapItemRef.current?.open({
                                projectId: +projectId,
                                type: "create",
                            })
                        }
                    >
                        Cadastrar Meta
                    </button>
                </section>
            </header>

            <Tabs
                defaultActiveKey={searchParams.get("tab") || "details"}
                transition={false}
                className="my-4"
                onSelect={handleOnClick}
            >
                <Tab eventKey="details" title="Secretaria">
                    <GovPlanProjectDetails project={data} />
                </Tab>
                <Tab eventKey="roadmap" title="Metas">
                    <GovPlanProjectRoadmapList project={data} />
                </Tab>
                {/* <Tab eventKey="history" title="Histórico">
                    Histórico
                </Tab> */}
            </Tabs>
            <ProjectRoadmapItemDetails ref={createRoadmapItemRef} />
        </>
    );
};
